import axios from "axios";

class AdminService {
  constructor() {
    this.API_URL = process.env.REACT_APP_API_URL_V;
    this.apiClient = axios.create({
      baseURL: this.API_URL,
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    });

    this.apiClient.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem("accesstoken");
        config.headers["x-auth-token"] = token;
        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );
  }

  async listUsers(data) {
    const response = await this.apiClient.post("/admins/users/list", data);
    return response.data.data;
  }
  async getssourl(data) {
    const response = await this.apiClient.post("/getssourl", data);
    return response.data.data;
  }
  async verifyAuth(accessToken) {
    try {
      const response = await this.apiClient.post(
        `/validateadauth`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,              
          },
        }
      )
      return response
    } catch (e) {
      console.log(e)
      console.log(e.message)

      return e.response
    }
  }

  async listAdmins(data) {
    // Ensure filterByRole is set to "superadmin"
    data.filterByRoleType = "superadmin";

    const response = await this.apiClient.post(
      "/admins/users/listformanager",
      data
    );
    return response.data.data;
  }
  async addAdmin(userData) {
    try {
      const response = await this.apiClient.post("/admins/users", userData);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }
  async listofManager(data) {
    const response = await this.apiClient.post("/admins/roles/listformanager", data);
    return  response.data.data;
  }

  async updateAdmin(adminId, adminData) {
    try {
      const response = await this.apiClient.put(
        `/admins/users/${adminId}`,
        adminData
      );
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }

  async deleteAdmin(adminId) {
    try {
      const response = await this.apiClient.delete(`/admins/users/${adminId}`);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
  async unlockUser(email) {
    try {
      const response = await this.apiClient.put("/admins/unlockuser", { email });
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AdminService();
